import React, { useEffect } from 'react';
import classNames from 'classnames';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import Loading from '../../shared/Loading';
import useSessionEntity from '../../../hooks/useSessionEntity';
import { loading } from '../../../actions/sessions';
import payOnline from '../../../images/navy-online-payments.svg'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function ApplyNowIntro() {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const merchant = useSessionEntity('merchant');

  useEffect(() => {
    dispatch(loading(false));
  }, []);

  if (!merchant) return <Loading active={true} />;

  return (
    <div className="has-text-centered mb-6">
      <div className="is-size-4 is-size-3-mobile has-text-weight-bold bnpl-heading">
        <p>Buy what you need, pay over time</p>
        <img src={payOnline} alt='pay-online-vector' className='image is-hidden-tablet' />
      </div>
      <hr className='is-hidden-mobile'/>
      <div className='intro-content'>
        <div className='intro-text'>
          <h2 className="is-size-5 is-size-6-mobile has-text-weight-bold">
            Fast, Easy Financing with No Money Down
          </h2>
          <p className="is-size-6 has-text-grey-dark mb-2">
            Instant decisions. Checking your rate will <strong>not</strong> affect
            your credit score.
          </p>
        </div>
        <div className="standard-overview-border mt-5 is-hidden-mobile">
          <div className="loan-terms-box">
            <div className="loan-terms">
              <p className="is-size-5">Up to</p>
              <span
                className="is-size-2 has-text-weight-bold"
                style={{ color: '#0983E3' }}
              >
                $50k
              </span>
              <p className="is-size-5">financing</p>
            </div>
            <div className="loan-terms">
              <p className="is-size-5">Pay</p>
              <span
                className="is-size-2 has-text-weight-bold"
                style={{ color: '#0983E3' }}
              >
                0%
              </span>
              <p className="is-size-5">
                for
                <span className="mx-1">
                  {merchant.get('active_promo')
                    ? merchant.get('active_promo').get('max_net_duration')
                    : 30}
                </span>
                days
              </p>
            </div>
            <div className="loan-terms">
              <p className="is-size-5">Up to</p>
              <span
                className="is-size-2 has-text-weight-bold"
                style={{ color: '#0983E3' }}
              >
                12
              </span>
              <p className="is-size-5">month terms</p>
            </div>
          </div>
        </div>
        <div className='widget-group is-flex is-justify-content-space-between is-align-items-center is-hidden-tablet'>
          <div className="widget-overview">
            <div className='icon-group-1'>
              <FontAwesomeIcon icon={['far', 'money-bill-trend-up']} className='has-text-white is-size-4' />
            </div>
            <div className="media-content">
              <div className='is-size-7' style={{lineHeight: '1.2rem', margin: '0.5rem auto'}}>
                Up to
                <p
                  className="is-size-5 has-text-weight-bold mx-2"
                  style={{ color: '#070d59' }}
                >
                  $50k
                </p> financing
              </div>
            </div>
          </div>
          <div className="widget-overview is-hidden-tablet">
            <div className='icon-group-2'>
              <FontAwesomeIcon icon={['far', 'badge-percent']} className='has-text-white is-size-4' />
            </div>
            <div className="media-content">
              <div className='is-size-7' style={{ lineHeight: '1.2rem', margin: '0.5rem auto' }}>
                Pay
                <p
                  className="is-size-5 has-text-weight-bold ml-2 mr-1"
                  style={{ color: '#070d59' }}
                >
                  0%
                </p> for
                <span className="mx-1">
                  {merchant.get('active_promo')
                    ? merchant.get('active_promo').get('max_net_duration')
                    : 30}
                </span>
                days
              </div>
            </div>
          </div>
          <div className="widget-overview is-hidden-tablet">
            <div className='icon-group-3'>
              <FontAwesomeIcon icon={['far', 'calendar-check']} className='has-text-white is-size-4' />
            </div>
            <div className="media-content">
              <div className='is-size-7' style={{ lineHeight: '1.2rem', margin: '0.5rem auto' }}>
                Up to
                <p
                  className="is-size-5 has-text-weight-bold mx-2"
                  style={{ color: '#070d59' }}
                >
                  12
                </p> month terms
              </div>
            </div>
          </div>
        </div>
      </div>
      <button
        className='mt-5 button is-primary is-large is-fullwidth has-text-weight-semibold intro-button'
        onClick={() => history.push(location.state.redirect_url)}
      >
        Let's Go
      </button>

      <p className="mt-4 has-text-weight-bold mb-6">
        Already have a Credit Key account?{' '}
        <span
          className="is-clickable"
          style={{ color: '#0683E3' }}
          onClick={() => history.push('/init/existing_user')}
        >
          Sign In
        </span>
      </p>
    </div>
  );
}